const TabPages = () => {
  return (
    <div>
      <h1>TabPages</h1>
    </div>
  );
};

export default TabPages;
